import {
  getDocumentAuditActionFriendlyLabel,
  isSignatureDocumentAuditAction,
} from './documentAuditDisplay';

export function formatDocumentAuditDetailsFriendly(actionName: string, raw: string | undefined | null): string {
  const signatureLabel = isSignatureDocumentAuditAction(actionName)
    ? getDocumentAuditActionFriendlyLabel(actionName)
    : undefined;
  if (signatureLabel && !raw?.trim()) {
    return signatureLabel;
  }
  if (!raw?.trim()) return '';
  try {
    const o = JSON.parse(raw) as Record<string, unknown>;
    if (typeof o !== 'object' || o === null) return raw;

    const from = o.from;
    const to = o.to;
    if ((typeof from === 'string' || typeof from === 'number') && (typeof to === 'string' || typeof to === 'number')) {
      const a = String(actionName || '').toLowerCase();
      if (a.includes('rename') || ('oldName' in o && 'newName' in o)) {
        return `Renomeado de "${from}" para "${to}"`;
      }
      return `De "${from}" para "${to}"`;
    }

    if ('oldName' in o && 'newName' in o) {
      return `Renomeado de "${o.oldName}" para "${o.newName}"`;
    }

    const friendlyPrefix = signatureLabel ? `${signatureLabel}. ` : '';

    return friendlyPrefix + Object.entries(o)
      .map(([k, v]) => {
        if (v !== null && typeof v === 'object') {
          return `${k}: ${JSON.stringify(v)}`;
        }
        return `${k}: ${String(v)}`;
      })
      .join(' · ');
  } catch {
    return raw;
  }
}
